import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Links } from 'settings';

import { BarW, Title, ButtonsRow, ActionButton } from './styled';

interface CreatePostActionBarProps {
  setIsCreateModalOpen: (open: boolean) => void;
}

interface Action {
  label: string;
  link?: string;
}

export function CreatePostActionBar({
  setIsCreateModalOpen,
}: CreatePostActionBarProps): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const actions: Action[] = [
    { label: t('we.quickActions.createPost'), link: Links.we.createPost },
    { label: t('we.quickActions.createPoll'), link: Links.we.createPoll },
    { label: t('we.quickActions.createTask'), link: Links.we.createTask },
    { label: t('we.quickActions.createfile') },
  ];

  return (
    <BarW>
      <Title>{t('we.quickActions.title')}</Title>
      <ButtonsRow>
        {actions.map(({ label, link }) => (
          <ActionButton
            key={label}
            onClick={() => {
              if (!link) {
                setIsCreateModalOpen(true);
              } else {
                navigate(link);
              }
            }}
          >
            {label}
          </ActionButton>
        ))}
      </ButtonsRow>
    </BarW>
  );
}
